import { render, staticRenderFns } from "./PAddProduct.vue?vue&type=template&id=1a933b96&scoped=true"
import script from "./PAddProduct.vue?vue&type=script&lang=js"
export * from "./PAddProduct.vue?vue&type=script&lang=js"
import style0 from "./PAddProduct.vue?vue&type=style&index=0&id=1a933b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a933b96",
  null
  
)

export default component.exports